export default {
  chatWidget: {
    chatWithUs: 'Chat with us',
    welcomeTitle: 'Welcome to Bookivo!',
    welcomeMessage: 'How can we help you today?',
    continueChat: 'Continue Chat',
    startConversation: 'Start Conversation',
    formTitle: 'Tell us more about yourself',
    namePlaceholder: 'Your name',
    emailPlaceholder: 'Your email',
    phonePlaceholder: 'Your phone number',
    nameRequired: 'Please enter your name',
    emailRequired: 'Please enter your email',
    emailInvalid: 'Please enter a valid email',
    phoneRequired: 'Please enter your phone number',
    startChat: 'Start Chat',
    chatTitle: 'Support Chat',
    chatTitleNoAgent: 'Connecting...',
    endChat: 'End Chat',
    inputPlaceholder: 'Type your message...',
    greeting: 'Hi',
    greetingMessage: 'How can I assist you today?',
    emoji: 'Emoji',
    uploadImage: 'Upload image',
    sending: 'Sending...',
    uploadFailed: 'Upload failed, please try again',
    fileTooLarge: 'File size cannot exceed 10MB',
    invalidFileType: 'Only image files can be uploaded',
    sendFailed: 'Message failed to send, please try again',
    imageSendFailed: 'Image failed to send, please try again',
    connectionLost: 'Connection lost, please close and reopen chat',
    uploading: 'Uploading image...',
    sessionEnded: 'Session ended',
    rating: {
      title: 'Thank you for using our service. Please rate your experience!',
      satisfied: 'Satisfied',
      dissatisfied: 'Dissatisfied',
      placeholder: 'Welcome to give us suggestions',
      submit: 'Submit Rating',
      endChat: 'End Chat',
      backToChat: 'Back to Chat',
      success: 'Thank you for your feedback!'
    }
  },
  imServer: {
    systemName: 'Distribution Fusion',
    online: 'Online',
    offline: 'Offline',
    noSession: 'No current sessions'
  },
  imClient: {
    chatWithUs: 'Chat with us',
    connecting: 'Connecting...',
    chattingWithAgent: 'You are chatting with customer service {agentName}',
    endConversation: 'End this conversation?',
    endSession: 'End Session',
    cancel: 'Cancel',
    continueConsult: 'Continue Consulting',
    sessionEnded: 'This session has ended',
    leave: {
      title: 'Currently no customer service online, please leave a message',
      phonePlaceholder: 'Phone (required)',
      emailPlaceholder: 'Email (required)',
      contentPlaceholder: 'Please enter 2-100 characters',
      submit: 'Submit',
      successTitle: 'MESSAGE SUBMITTED SUCCESSFULLY',
      successSubtitle: 'We will contact you soon',
      emailError: 'Please enter a valid email',
      phoneError: 'Please enter a valid phone number',
      contentError: 'Please enter 2-100 characters'
    },
    rate: {
      title: 'Thank you for using our service, please rate this experience!',
      satisfied: 'Satisfied',
      dissatisfied: 'Dissatisfied',
      suggestionPlaceholder: 'Welcome to give suggestions for our service',
      submit: 'Submit Rating',
      endNow: 'End Now',
      backToChat: 'Back to Chat',
      success: 'Rating submitted successfully'
    },
    transfer: {
      startConsult: 'Start Consulting'
    }
  },
  common: {
    emoji: 'Emoji',
    image: 'Image',
    uploadImage: 'Image',
    loadMoreHistory: 'View more history',
    noMoreHistory: 'No more messages',
    historyEnd: '— Above is history —',
    system: 'System',
    assignFailMsg: 'Failed to assign customer service, please contact administrator',
    download: 'Download',
    noRobotConfig: 'No robot configured, ',
    transferAgent: 'Transfer to Agent',
    inputPlaceholder: 'Type a message...',
    send: 'Send',
    continueConsult: 'Continue',
    close: 'Close',
    quote: 'Quote',
    fileSizeLimit: 'File size cannot exceed 10MB',
    evaluation: 'Rate'
  }
}